import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { DisabledFeaturesService } from './disabled-features.service';

export const ngxDisabledFeaturesServiceModule = angular.module('ngxDisabledFeaturesServiceModule', [])
	.factory('ngxDisabledFeaturesService', downgradeInjectable(DisabledFeaturesService) as any)
	.name;
